import {ReceiptTypeDto, ShipmentTypeDto} from "../../api/kpi";

type Prefix = 'receipt' | 'exit';

export type PrefixedShipmentType = `${Prefix}_${ShipmentTypeDto}`
export type PrefixedReceiptType = `${Prefix}_${ReceiptTypeDto}`
export type ChartDataItemType = { date: string, receipt?: number, exit?: number } & Partial<Record<PrefixedShipmentType, number>>
export type ChartDataItemReceiptType = { date: string } & Partial<Record<ReceiptTypeDto, number>>
export type ChartColorType = Record<ShipmentTypeDto, string>
export type ChartOrderType = Record<ShipmentTypeDto, number>
export type ChartColorReceiptType = Record<ReceiptTypeDto, string>
export type ChartOrderReceiptType = Record<ReceiptTypeDto, number>

export interface KpiShippingLoadParams {
    fromRelative?: string
    toRelative?: string
    fromAbsolute?: string
    toAbsolute?: string
    customerId?: string
}

const typeOrder: ChartOrderType = {
    MORNING: 1,
    LATE_MORNING: 2,
    NOON: 3,
    TRACKED: 4,
    POST: 5
}

const receiptTypeOrder: ChartOrderReceiptType = {
    SCAN_COMPLETE: 1,
    ACQUISITION_COMPLETE: 2,
    PLACEMENT_COMPLETE: 3,
    SCAN_RECORD_COMPLETE: 4,
    ACQUISITION_RECORD_COMPLETE: 5,
    PLACEMENT_RECORD_COMPLETE: 6
}

const sortedShipmentTypes = Object.keys(ShipmentTypeDto)
    .map(e => e as ShipmentTypeDto)
    .sort((a, b) => typeOrder[a] - typeOrder[b])
const sortedReceiptTypes = Object.keys(ReceiptTypeDto)
    .map(e => e as ReceiptTypeDto)
    .sort((a, b) => receiptTypeOrder[a] - receiptTypeOrder[b])

export {
    typeOrder,
    sortedShipmentTypes,
    receiptTypeOrder,
    sortedReceiptTypes
}
